import { useEffect, useState } from "react";
import axiosInstance from "../components/api/axiosInstance";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const OWNER_EMAIL_INFO =
  "The owner signs in with this company email. Gmail, Outlook and Yahoo addresses are not allowed.";

/**
 * Looks up whether a company email already signs in to Cloud Office.
 * Returns the existing person ({ First_Name, Last_Name, businesses }) or null.
 * Pass ``skip`` to disable the lookup (e.g. the email is the tenant's current owner).
 */
export default function useOwnerLookup(email, { skip = false } = {}) {
  const [existing, setExisting] = useState(null);

  useEffect(() => {
    const value = String(email || "").trim();
    if (skip || !EMAIL_PATTERN.test(value)) {
      setExisting(null);
      return undefined;
    }
    let active = true;
    const timer = setTimeout(async () => {
      try {
        const res = await axiosInstance.get("/owner-lookup", { params: { email: value } });
        if (active) setExisting(res.data?.exists ? res.data : null);
      } catch (_) {
        if (active) setExisting(null);
      }
    }, 400);
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [email, skip]);

  return existing;
}

export function describeExistingOwner(person) {
  if (!person) return "";
  const name = `${person.First_Name || ""} ${person.Last_Name || ""}`.trim() || "This person";
  const companies = (person.businesses || [])
    .map((b) => (b.Is_Platform ? "Tumma staff" : b.Company_Name))
    .filter(Boolean);
  const where = companies.length ? ` (${companies.join(", ")})` : "";
  return `${name} already signs in with this email${where}. They will also become the owner of this company and keep their current password.`;
}
